module.exports = __webpack_public_path__ + "static/media/logo_leipzig.b4af6ae3.png";